<script>
import { mapState, mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default {
  props: {
    facility: {
      default: null,
    },
    module: {
      default: null,
    },
  },

  data() {
    return {
      facilityId: null,
      min_wattage: null,
      target_wattage: null,
      max_wattage: null,
      module_id: null,
      module_type: null,
      display_order: null,
      notes: null,
    };
  },

  // When the component is created, fetch the inactive workers
  async created() {
    this.facilityId = this.facility.id;
    this.min_wattage = this.module.min_wattage;
    this.target_wattage = this.module.target_wattage;
    this.max_wattage = this.module.max_wattage;
    this.module_id = this.module.id;
    this.module_type = this.module.module_type;
    this.display_order = this.module.display_order;
    this.notes = this.module.notes;
  },

  computed: {
    // The group statistics
    statistics() {
      return this.groupStatistics[this.facility.group_id];
    },
    // Mapped state
    ...mapGetters(["can"]),
    ...mapState(["facilities", "groupStatistics"]),
  },

  mounted: function () {
    this.$nextTick(function () {
      var slider = document.getElementById("myRange");
      var percentage =
        ((this.module.target_wattage - this.module.min_wattage) /
          (this.module.max_wattage - this.module.min_wattage)) *
        100;
      slider.style.background =
        "linear-gradient(to right, #007bff 0%, #007bff " +
        percentage +
        "%, gray " +
        percentage +
        "%, gray 100%)";
    });
  },

  methods: {
    sliderInput() {
      var slider = document.getElementById("myRange");
      this.target_wattage = slider.value;
      var percentage =
        ((this.target_wattage - this.min_wattage) /
          (this.max_wattage - this.min_wattage)) *
        100;
      slider.style.background =
        "linear-gradient(to right, #007bff 0%, #007bff " +
        percentage +
        "%, gray " +
        percentage +
        "%, gray 100%)";
    },

    // Post a new group to the API from the form inputs
    async updateFacilityTarget() {
      // Add group given the form inputs
      await this.updateFacility({
        facilityId: this.facilityId,
        module_type: this.module_type,
        module_id: this.module_id,
        min_wattage: this.min_wattage,
        max_wattage: this.max_wattage,
        target_wattage: this.target_wattage,
        display_order: this.display_order,
        notes: this.notes,
      });
    },

    debounceInput: _.debounce(function () {
      this.updateFacilityTarget();
    }, 5000),

    ...mapActions(["getFacility", "updateFacility"]),
  },
};
</script>

<template>
  <div>
    <p>
      <b>Adjust the number of miners you would like to be running</b>
    </p>
    <b-card class="mb-3">
      <b-row>
        <b-col
          cols="12"
          :sm="can.facilities.view ? 4 : 6"
          class="mycontent-left mb-2 mb-sm-0"
        >
          <p class="text-center">
            <span class="Facilities-span">
              {{ "~ " + target_wattage + " W" }}
            </span>
            <br />
            <span class="Facilities-mini-span">
              <b>Target Wattage</b>
            </span>
          </p>
        </b-col>
        <b-col>
          <b-card-text>
            <p class="text-center">
              <span class="Facilities-mini-span">
                <b>Active Workers</b>
                <br />
                {{ statistics.active_count }} / {{ statistics.count }}
              </span>
            </p>
            <div class="slidecontainer">
              <input
                model="myRange"
                type="range"
                class="slider"
                id="myRange"
                :min="min_wattage"
                :max="max_wattage"
                :value="target_wattage"
                step="1"
                v-on:change="debounceInput"
                v-on:input="sliderInput"
              />
            </div>
          </b-card-text>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<style scoped>
.mycontent-left {
  border-right: 3px dashed #333;
}

.Facilities-span {
  font-size: 275%;
}

.Facilities-mini-span {
  font-size: 125%;
}

.slidecontainer {
  width: 100%; /* Width of the outside container */
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;
  background: linear-gradient(to right, #007bff 100%);
  outline: none;
  opacity: 0.7;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 25%;
  background: #004fa3;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 25%;
  background: #004fa3;
  cursor: pointer;
}
</style>
